import { EventLog } from "../Model/EventLog";
import DateUtil from "./DateUtil";
import LightPathUtil from "./LightPathUtil";

class EventLogUtil {
  static toName(field: string) {
    switch (field) {
      case "userName":
        return "User Name";
      case "group":
        return "Group";
      default:
        return "Plate Type";
    }
  }

  static toField(fieldName: string) {
    switch (fieldName) {
      case "User Name":
        return "userName";
      case "Group":
        return "group";
      default:
        return "plateTypeName";
    }
  }

  static exportToPlainText(eventLog: EventLog[]): string {
    let text = "";
    const header =
      "Time\tEvent Type\tPlate ID\tInp. ID\tPlate Type\tLight Path\tSetting\tProject\tExperiment\tUser Name\tGroup\tImaging Duration\n";

    text += header;

    eventLog.forEach((log) => {
      text += `${log.createdDate}\t${log.description}\t${log.plateId}\t${
        log.imagingId
      }\t${log.plateTypeName}\t${LightPathUtil.toName(log.lightPath)}\t${
        log.captureProfileName
      }\t${log.projectName}\t${log.experimentName}\t${log.userName}\t${
        log.userGroup
      }\t${DateUtil.convertMinutesToHHMMSS(log.durationInMinute)}\n`;
    });

    return text;
  }
}

export default EventLogUtil;
